import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=bd81fd1c&"
import script from "./MediaItem.vue?vue&type=script&lang=ts&"
export * from "./MediaItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports